import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import NavBarTop from "../Reusable_Components/NavBarTop";
import LeftNavBar from "../Reusable_Components/LeftNavBar";
import TableComponent from "../Reusable_Components/TableComponent";
import Pagination from "../Reusable_Components/Pagination";
import { GoSearch } from 'react-icons/go';
import { ACLS, CEO_GROUP, COMMERCIAL_HEAD_GROUP, FACILITY_MANAGER_GROUP, FINANCE_MANAGER_GROUP, PORTOS_CUSTOMER_GROUP, RECORDS_PER_PAGE_METER_MASTER, TECHNICIAN_GROUP } from "../../Config";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import UploadComponent from '../Reusable_Components/UploadComponent';
import axios from 'axios';
import Loader from '../Reusable_Components/loader';
import {
    getInvoicePayments,
    commercialHeadGetAllFacilitiesForNav,
    SET_ERROR_FALSE, CONTRACT_API_LOADER_TRIGGER_TRUE, uploadPaymentDocuments, getAllDocumentsForPayment, handleDocumentLoaderTrue, sendPaymentsMail,
    getAllServices,
} from '../../Redux/Actions/Actions';
import { useDispatch, useSelector } from 'react-redux';
import { base_url } from '../../utilities';
// import SearchableDropdown from '../Reusable_Components/SearchableDropdown.jsx';
import SearchableDropdown from '../Reusable_Components/SearchableDropdown';
import AlertPopUp from '../Reusable_Components/Alert';
import Footer from '../Login/Footer';
import { formatCurrencyBasedOnRegion, formatNumericparseFloatInput, formatNumericInput, eleminateSpacesAtStartOfInputField } from '../Reusable_Components/ReusableFunctions'
import { set } from 'date-fns';
import { useLocation } from 'react-router-dom';
import { HiChevronDown, HiChevronUp } from 'react-icons/hi';

const FinanceManagerPayments = () => {

    const location = useLocation()
    const { props } = location.state || {};

    useEffect(() => {
        const details = {
            payment_id: props?.entity_details?.payment_id,
        }
        console.log("details", details)
        if (details?.payment_id) {
            handleViewActionClicked(details)
        }
    }, [props])

    const dispatch = useDispatch();
    const contractApiLoader = useSelector(state => state.contractApiLoader);
    const allPaymentDocuments = useSelector(state => state.allPaymentDocuments);
    const documentLoaderTrigger = useSelector(state => state.documentLoaderTrigger);
    const servicesForDropdown = useSelector((state) => state.servicesList);

    useEffect(() => {
        if (allPaymentDocuments) {
            setDocumentListArray(allPaymentDocuments)
            // setIsLoading(false)
        }
    }, [allPaymentDocuments])


    useEffect(() => {
        dispatch(commercialHeadGetAllFacilitiesForNav())
        dispatch(getAllServices())
    }, [dispatch]);

    const error = useSelector(state => state.error);
    const [alertShow, setAlertShow] = useState(false)
    const [alertType, setAlertType] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [alertValue, setAlertValue] = useState('')
    const [alertButtons, setAlertButtons] = useState([])
    const [alertAction, setAlertAction] = useState([])
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setErrorValue(error?.response?.data.message);
        if (error?.response?.data.message || error?.data?.data[1]?.message) {
            setAlertShow(true)
            setAlertType('error')
            setAlertMessage('Error')
            setAlertValue(error?.data?.data[1] ? error?.data?.data[1].message : error?.response?.data.message)
            setAlertButtons([{
                name: 'Close', action: () => {
                    setAlertShow(false)
                    dispatch({
                        type: SET_ERROR_FALSE,
                        payload: null
                    })
                }
            }])
        }
        setIsLoading(false);
    }, [error])

    const [facilityList, setFacilityList] = useState([]);
    const [errorValue, setErrorValue] = useState('');
    const [selectedfacility, setSelectedFacility] = useState(`${localStorage.getItem("selected_city_name")}, ${localStorage.getItem("selected_facility_name")}`);
    const facilitiesListForNav = useSelector(state => state.facilitiesListForNav);
    const [selectedFacilityId, setSelectedFacilityId] = useState(localStorage.getItem("selected_facility_id"));
    const [selectedFacilityName, setSelectedFacilityName] = useState(localStorage.getItem("selected_facility_name"));
    const [selectedCityName, setSelectedCityName] = useState(localStorage.getItem("selected_city_name"));
    const [isFacilitySelected, setIsFacilitySelected] = useState(selectedfacility);


    useEffect(() => {
        if (facilitiesListForNav) {
            const options = facilitiesListForNav?.map((facility) => `${facility.city}, ${facility.name}`);
            setFacilityList(options);
        }
    }, [facilitiesListForNav]);

    const [searchText, setSearchText] = useState('');
    const [amountDue, setAmountDue] = useState();




    const [invoiceTypeFilter, setInvoiceTypeFilter] = useState('');
    const [paymentStatusFilter, setPaymentStatusFilter] = useState('');
    const [billingMonthFilter, setBillingMonthFilter] = useState(dayjs().month() + 1);
    const [billingYearFilter, setBillingYearFilter] = useState(dayjs().year());



    useEffect(() => {
        let filter_condition_validate = {};
        if (invoiceTypeFilter === '') {
            filter_condition_validate = {
                facility_id: localStorage.getItem('selected_facility_id'),
                invoice_month: billingMonthFilter,
                invoice_year: billingYearFilter,
                status: paymentStatusFilter !== '' ? paymentStatusFilter : undefined,
            }
        } else {
            filter_condition_validate = {
                facility_id: localStorage.getItem('selected_facility_id'),
                invoice_type: invoiceTypeFilter,
                invoice_month: billingMonthFilter,
                invoice_year: billingYearFilter,
                status: paymentStatusFilter !== '' ? paymentStatusFilter : undefined,
            }
        }
        dispatch(getInvoicePayments(
            {
                page_number: 1,
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                search_text: searchText,
                filter_condition: filter_condition_validate
            }
        ))
    }, [dispatch])

    const totalRecords = useSelector((state) => state.allInvoicePayments?.info?.total_no_of_records);
    const currentPaginationPage = useSelector((state) => state.allInvoicePayments?.info?.page_number);
    const allInvoicePayments = useSelector((state) => state.allInvoicePayments?.data);


    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };

    const [contractName, setContractName] = useState('');
    const [invoiceNumber, setInvoiceNumber] = useState('');
    const [invoiceType, setInvoiceType] = useState('');
    const [issueDate, setIssueDate] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [invoicedAmount, setInvoicedAmount] = useState('');
    const [totalReceivedAmount, setTotalReceivedAmount] = useState('');
    const [paymentStatus, setPaymentStatus] = useState('');
    const [selectedPaymentId, setSelectedPaymentId] = useState('');

    const [totalBaseAmount, setTotalBaseAmount] = useState('');
    const [totalTDSAmount, setTotalTDSAmount] = useState('');
    const [totalCGSTAmount, setTotalCGSTAmount] = useState('');
    const [totalSGSTAmount, setTotalSGSTAmount] = useState('');
    const [totalIGSTAmount, setTotalIGSTAmount] = useState('');
    const [tdsPercentage, setTdsPercentage] = useState('');

    function base64ToArrayBuffer(base64) {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }

    const handleDownloadPayment = (data) => {
        setIsLoading(true);
        const body = {
            contract_number: data.contract_number,
            task: "pdf"
        }

        if (data.status === "fullypaid") {
            setIsLoading(false)
            setAlertShow(true)
            setAlertType('error')
            setAlertMessage('Error')
            setAlertValue("Payment is fully paid")
            setAlertButtons([{
                name: 'Close', action: () => {
                    setAlertShow(false)
                }
            }])
            return
        }
        else {
            axios.post(base_url + "payments/paymentGenerator", body)
                .then((response) => {
                    const url = window.URL.createObjectURL(
                        new Blob([base64ToArrayBuffer(response.data.data.pdf)], {
                            type: "application/pdf",
                        })
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `${data.contract_name}-Payment-Due.pdf`);
                    document.body.appendChild(link);
                    link.click();

                    setIsLoading(false)
                    setAlertShow(true)
                    setAlertType('success')
                    setAlertMessage('Success')
                    setAlertValue(<>
                        <p>
                            Payment records downloaded successfully
                        </p>
                    </>)
                    setAlertButtons([{
                        name: 'Close', action: () => {
                            setAlertShow(false)
                        }
                    }])
                })
                .catch((err) => {
                    setIsLoading(false)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(err?.response?.data.message)
                    setAlertButtons([{
                        name: 'Close', action: () => {
                            setAlertShow(false)
                        }
                    }])
                })
        }
    }
    const [creditDebitNotesList, setCreditDebitNotesList] = useState([]);




    const handleViewActionClicked = (data) => {

        dispatch({
            type: CONTRACT_API_LOADER_TRIGGER_TRUE,
            payload: true
        })
        dispatch(getAllDocumentsForPayment(data.payment_id))
        axios.get(base_url + "payments", {
            params: {
                filter_condition: JSON.stringify({
                    payment_id: data.payment_id
                })
            }
        })
            .then((response) => {
                dispatch({
                    type: CONTRACT_API_LOADER_TRIGGER_TRUE,
                    payload: false
                })
                const data1 = response.data.data[0];
                setContractName(data1.contract_name);
                setInvoiceNumber(data1.invoice_number);
                setInvoiceType(data1.invoice_type);
                setIssueDate(data1.issue_date);
                setDueDate(data1.due_date);
                setInvoicedAmount(data1.invoiced_amount);
                setTotalReceivedAmount(data1.total_received_amount);
                setPaymentStatus(data1.status);
                setAmountDue(data1.amount_due);
                setPaymentRecordsRows(data1.payment_details);
                setSelectedPaymentId(data1.payment_id);
                setTotalBaseAmount(data1.total_base_amount);
                setTotalTDSAmount(data1.tds_amount);
                setTotalCGSTAmount(data1.total_cgst);
                setTotalSGSTAmount(data1.total_sgst);
                setTotalIGSTAmount(data1.total_igst);
                setTdsPercentage(data1.tds_percentage);
                setAdjustmentAmount(data1.adjustment_amount);
                setAdjustmentType(data1.type);
                setAdjustmentReason(data1.reason);
                setCurrentPage(2)
                console.log("data1.payment_details", data1.payment_details)
                console.log("data1", data1)
                const cdDetails = data1.payment_details
                setCreditDebitNotesList(cdDetails.filter((each) => each.entry_type === "credit_note" || each.entry_type === "debit_note"))
            })
            .catch((error) => {
                dispatch({
                    type: CONTRACT_API_LOADER_TRIGGER_TRUE,
                    payload: false
                })
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error ')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        setAlertValue('')
                        setAlertMessage('')
                        setAlertType('')
                        backFunction()
                    }
                }])
            })
    }

    const sendPaymentMailConfirmation = (data) => {
        setAlertShow(true)
        setAlertType('question')
        setAlertMessage('Confirmation')
        setAlertValue("Are you sure you want to send payment mail?")
        setAlertButtons([{
            name: 'Cancel', action: () => {
                setAlertShow(false)
            }
        }, {
            name: 'Confirm', action: () => {
                // Call the function to send the payment mail
                handleEditActionClicked(data)
                setAlertShow(false)
            }
        }])
    }

    const handleEditActionClicked = (data) => {
        setIsLoading(true);
        // const body = {
        //     content:{
        //     invoice_number : data.invoice_number,
        //     invoice_type : data.invoice_type,
        //     issue_date : data.issue_date,
        //     due_date : data.due_date,
        //     invoiced_amoount: parseInt(data.invoiced_amount, 10),
        //     total_amount_received: parseInt(data.total_received_amount, 10),
        //     month : data.invoice_month,
        //     year : data.invoice_year,
        //     amount_due : parseInt(data.amount_due,10),
        //     status : data.status,
        //     }
        // }

        const body = {
            contract_number: data.contract_number,
            task: "email"
        }
        axios.post(base_url + "payments/paymentGenerator", body)
            .then((res) => {
                setIsLoading(false)
                setAlertShow(true)
                setAlertType('success')
                setAlertMessage('Success')
                setAlertValue(<>
                    <p>
                        Payment mail sent successfully
                    </p>
                </>)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                    }
                }])
            })
            .catch((err) => {
                setIsLoading(false)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(err?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                    }
                }])
            })


    }

    const handledPaginationNextClicked = () => {

        let filter_condition_validate = {};
        if (invoiceTypeFilter === '') {
            filter_condition_validate = {
                facility_id: selectedFacilityId,
                invoice_month: billingMonthFilter,
                invoice_year: billingYearFilter,
                status: paymentStatusFilter !== '' ? paymentStatusFilter : undefined,
            }
        } else {
            filter_condition_validate = {
                facility_id: selectedFacilityId,
                invoice_type: invoiceTypeFilter,
                invoice_month: billingMonthFilter,

                invoice_year: billingYearFilter,
                status: paymentStatusFilter !== '' ? paymentStatusFilter : undefined,
            }
        }
        dispatch(getInvoicePayments({
            page_number: currentPaginationPage + 1,
            items_per_page: RECORDS_PER_PAGE_METER_MASTER,
            search_text: searchText,
            filter_condition: filter_condition_validate
        }))

    }

    const handledPaginationPrevClicked = () => {
        let filter_condition_validate = {};
        if (invoiceTypeFilter === '') {
            filter_condition_validate = {
                facility_id: selectedFacilityId,
                invoice_month: billingMonthFilter,
                invoice_year: billingYearFilter,
                status: paymentStatusFilter !== '' ? paymentStatusFilter : undefined,
            }
        } else {
            filter_condition_validate = {
                facility_id: selectedFacilityId,
                invoice_type: invoiceTypeFilter,
                invoice_month: billingMonthFilter,

                invoice_year: billingYearFilter,
                status: paymentStatusFilter !== '' ? paymentStatusFilter : undefined,
            }
        }
        dispatch(getInvoicePayments({
            page_number: currentPaginationPage - 1,
            items_per_page: RECORDS_PER_PAGE_METER_MASTER,
            search_text: searchText,
            filter_condition: filter_condition_validate
        }))

    }

    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState('1');

    const [paymentRecordsRows, setPaymentRecordsRows] = useState(
        [{
            payment_date: "",
            amount_paid: "",
            account_no: "",
            instrumentation_type: "",
            note: "",
        }]
    );

    const handleAddPaymentRecordRow = () => {
        const newPaymentRecordsRow = {
            payment_id: selectedPaymentId,
            payment_date: "",
            amount_paid: "",
            account_no: "",
            instrumentation_type: "",
            note: "",
            entry_type: "payment"
        }
        setPaymentRecordsRows([...paymentRecordsRows, newPaymentRecordsRow]);
    }

    const handleRemovePaymentRecordRow = (index) => {
        const newPaymentRecordsRows = paymentRecordsRows.filter((row, i) => i !== index);
        setPaymentRecordsRows(newPaymentRecordsRows);
    }

    const handleBillingPeriodChange = (newValue) => {
        setBillingMonthFilter(dayjs(newValue).month() + 1);
        setBillingYearFilter(dayjs(newValue).year());
    }

    const applyFilterClicked = () => {
        localStorage.setItem("selected_facility_id", selectedFacilityId);
        localStorage.setItem("selected_facility_name", selectedFacilityName);
        localStorage.setItem("selected_city_name", selectedCityName);

        let filter_condition_validate = {};

        if (invoiceTypeFilter === '') {
            filter_condition_validate = {
                facility_id: selectedFacilityId,
                invoice_month: billingMonthFilter,
                invoice_year: billingYearFilter,
                status: paymentStatusFilter !== '' ? paymentStatusFilter : undefined,
            }
        } else {
            filter_condition_validate = {
                facility_id: selectedFacilityId,
                invoice_type: invoiceTypeFilter,
                invoice_month: billingMonthFilter,
                invoice_year: billingYearFilter,
                status: paymentStatusFilter !== '' ? paymentStatusFilter : undefined,
            }
        }
        dispatch(getInvoicePayments(
            {
                page_number: 1,
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                search_text: searchText,
                filter_condition: filter_condition_validate
            }
        ))
    }

    const clearFilterClicked = () => {
        const currentMonth = dayjs().month() + 1;
        const currentYear = dayjs().year();
        setInvoiceTypeFilter('');
        setPaymentStatusFilter('');
        setBillingMonthFilter(currentMonth);
        setBillingYearFilter(currentYear);
        setSearchText('');
        dispatch(getInvoicePayments(
            {
                page_number: 1,
                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                search_text: '',
                filter_condition: {
                    facility_id: localStorage.getItem('selected_facility_id'),
                    invoice_month: dayjs().month() + 1,
                    invoice_year: dayjs().year(),
                }
            }
        ))
    }

    const handlePaymentRecordsRowChange = (e, index, key) => {

        const newPaymentRecordsRows = paymentRecordsRows.map((row, i) => {
            if (i === index) {
                return {
                    ...row,
                    [key]: key === 'amount_paid' ? parseFloat(formatNumericparseFloatInput(e.target.value)) :
                        (key === 'payment_date' ? e.format('YYYY-MM-DD') : eleminateSpacesAtStartOfInputField(e.target.value))
                }
            }
            return row;
        });
        setPaymentRecordsRows(newPaymentRecordsRows);
    }

    const backFunction = () => {
        setCurrentPage(1)
        setContractName('');
        setInvoiceNumber('');
        setInvoiceType('');
        setIssueDate('');
        setDueDate('');
        setInvoicedAmount('');
        setTotalReceivedAmount('');
        setPaymentStatus('');
        setAmountDue('');
        setTotalTDSAmount('');
        setTotalBaseAmount('');
        setTotalCGSTAmount('');
        setTotalSGSTAmount('');
        setTotalIGSTAmount('');
        setDocumentListArray([]);
        setTdsPercentage('');
        setEditTdsClicked(false);
        setAdjustmentAmount('0');
        setAdjustmentType('');
        setAdjustmentReason('');
        setIsExpandedCreditDebitNotes(true);
        setPaymentRecordsRows([{
            payment_date: "",
            amount_paid: "",
            account_no: "",
            instrumentation_type: "",
            note: "",
        }]);
    }

    const handleSavePayment = () => {
        dispatch({
            type: CONTRACT_API_LOADER_TRIGGER_TRUE,
            payload: true
        })
        setIsLoading(true);
        let body = {}
        if (editTdsClicked) {
            body = {
                payment_id: selectedPaymentId,
                tds_percentage: tdsPercentage,
                payments: paymentRecordsRows,
                adjustment_amount: adjustmentAmount,
                type: adjustmentType,
                reason: adjustmentReason
            }
        }
        else {
            body = {
                payment_id: selectedPaymentId,
                payments: paymentRecordsRows,
                adjustment_amount: adjustmentAmount,
                type: adjustmentType,
                reason: adjustmentReason
            }
        }

        axios.put(base_url + "payments", body)
            .then((response) => {
                dispatch({
                    type: CONTRACT_API_LOADER_TRIGGER_TRUE,
                    payload: false
                })

                setIsLoading(false);
                setAlertShow(true)
                setAlertType('success')
                setAlertMessage('Success')
                setAlertValue(<>
                    <p>
                        Payment records saved successfully
                    </p>
                </>)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        let filter_condition_validate = {};

                        if (invoiceTypeFilter === '') {
                            filter_condition_validate = {
                                facility_id: selectedFacilityId,
                                invoice_month: billingMonthFilter,
                                invoice_year: billingYearFilter,
                                status: paymentStatusFilter !== '' ? paymentStatusFilter : undefined,
                            }
                        } else {
                            filter_condition_validate = {
                                facility_id: selectedFacilityId,
                                invoice_type: invoiceTypeFilter,
                                invoice_month: billingMonthFilter,
                                invoice_year: billingYearFilter,
                                status: paymentStatusFilter !== '' ? paymentStatusFilter : undefined,
                            }
                        }
                        dispatch(getInvoicePayments(
                            {
                                page_number: 1,
                                items_per_page: RECORDS_PER_PAGE_METER_MASTER,
                                search_text: searchText,
                                filter_condition: filter_condition_validate
                            }
                        ))
                        setCurrentPage(1)
                        backFunction()
                        setAlertShow(false)
                    }
                }])
            })
            .catch((error) => {
                dispatch({
                    type: CONTRACT_API_LOADER_TRIGGER_TRUE,
                    payload: false
                })
                setIsLoading(false);
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error ')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                        // backFunction()
                    }
                }])
            })
    }

    const [uploadedFiles, setUploadedFiles] = useState();

    const handleFilesSelected = (files) => {
        const processedFiles = [];
        files.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = function () {
                const base64FileContent = reader.result.split(",")[1];
                const required_id = selectedPaymentId
                const processedFile = {
                    file_content: base64FileContent,
                    object_type: "payments_document",
                    file_description: file.description,
                    file_type: file.file.type.split("/")[1],
                    file_name: file.file.name,
                    file_size: file.file.size,
                    flag: file.flag,
                    user_id: localStorage.getItem('username'),
                    payment_id: required_id,
                };
                processedFiles.push(processedFile);
                if (processedFiles.length === files.length) {
                    setUploadedFiles(processedFiles);
                }
            };
            reader.readAsDataURL(file.file);
        });
    };

    const [documentsListArray, setDocumentListArray] = useState([])
    const handleDocumentUpload = (index) => {
        dispatch(handleDocumentLoaderTrue())
        dispatch(uploadPaymentDocuments(
            {
                files: [uploadedFiles[index]]
            }
        ))
    }

    const handleErrorFromDocument = (value) => {
        setErrorValue(value)
    }

    const handleEnable = (each) => {
        return false;
    }

    const [editTdsClicked, setEditTdsClicked] = useState(false);

    const [adjustmentAmount, setAdjustmentAmount] = useState('0');
    const [adjustmentType, setAdjustmentType] = useState('');
    const [adjustmentReason, setAdjustmentReason] = useState('');


    const handleAdjustmentAmountChange = (e) => {
        // setAdjustmentAmount(parseFloat(formatNumericparseFloatInput(e.target.value)));
        const parts = e.target.value.split('.');
        const integerPart = parts[0];
        const decimalPart = parts.length > 1 ? '.' + parts[1].substring(0, 2) : '';
        const formattedInput = integerPart + decimalPart;
        setAdjustmentAmount(formattedInput);
    }

    const handleAdjustmentTypeChange = (e) => {
        setAdjustmentType(e.target.value);
    }

    const handleAdjustmentReasonChange = (e) => {
        setAdjustmentReason(e.target.value);
    }

    const [showSendMailConfirm, setShowSendMailConfirm] = useState(false);
    const [selectedMailData, setSelectedMailData] = useState(null);

    //credit note debit notes state

    const [isExpandedCreditDebitNotes, setIsExpandedCreditDebitNotes] = useState(true);


    const getGroupNameOriginal = (val) => {
        switch (val) {
            case "Commercial Head":
                return COMMERCIAL_HEAD_GROUP;
            case "Technician":
                return TECHNICIAN_GROUP;
            case "Finance Manager":
                return FINANCE_MANAGER_GROUP;
            case "Facility Manager":
                return FACILITY_MANAGER_GROUP;
            case "CEO":
                return CEO_GROUP;
            case "Customer":
                return PORTOS_CUSTOMER_GROUP;
            default:
                return "";
        }
    }
    const isManage = ACLS[getGroupNameOriginal(localStorage.getItem('group'))].find(obj => obj.ROUTE === "/financeManagerPayments" && obj.PERMISSIONS?.includes("MANAGE"));

    return (
        <>
            <>
                <NavBarTop />
                <LeftNavBar />
                {
                    contractApiLoader || isLoading ? <Loader /> : null
                }
                <AlertPopUp alertShow={alertShow} alertType={alertType} alertMsg={alertMessage} alertValue={alertValue} alertButtons={alertButtons} />
            </>
            {
                currentPage === 1 &&
                <div className='meter_reports_container'>


                    <div className='d-flex justify-content-between align-items-center flex-wrap'>
                        <div className='d-flex align-items-center gap-3 mb-3'>
                            <h3 className="invoice-heading" >Payments</h3>
                        </div>
                    </div>



                    <div className='fm-invoice-con-filters' style={{ zIndex: 100 }}>
                        <div style={{ width: '280px' }} className="meter-report-filters fin_man_billing_period">
                            <p style={{ marginBottom: '-15px' }}>Facility:&nbsp;</p>
                            <SearchableDropdown
                                style={{ zIndex: 100 }}
                                // className = "searchable-dropdown2"
                                options={facilityList ? facilityList : []} //facilityList is the array of facilities
                                selectedOption={selectedfacility}
                                noOptionsAvailable="Facility unavailable"
                                onChange={(e) => {
                                    setSelectedFacility(e.value)
                                    const selectedFacility = facilitiesListForNav?.find((facility) => `${facility.city}, ${facility.name}` === e.value);
                                    setSelectedFacilityName(selectedFacility?.name);
                                    setSelectedCityName(selectedFacility?.city);
                                    setSelectedFacilityId(selectedFacility?.facility_id);
                                    setIsFacilitySelected(true);
                                }}

                                placeholder="Select Facility"
                                isDisabled={false}
                            />
                        </div>
                        <div className="meter-report-filters payments-select-container fin_man_billing_period">
                            <p style={{ marginBottom: '5px' }}>Invoice Type:&nbsp;</p>
                            <select
                                value={invoiceTypeFilter}
                                onChange={(e) => {
                                    setInvoiceTypeFilter(e.target.value);
                                }}
                                className="form-select payments-select invoice-select-date"
                                style={{ width: "100%", height: "2.5rem" }}
                            >
                                <option value={""}>All Invoices</option>
                                <option value="miscellaneous">Miscellaneous</option>
                                {servicesForDropdown?.map((service, index) => (
                                    <option key={index} value={service.service_code}>{service.service_name}</option>
                                ))}
                                { }
                            </select>
                        </div>
                        <div className="meter-report-filters payments-select-container fin_man_billing_period">
                            <p style={{ marginBottom: '5px' }}>Payment Status:&nbsp;</p>
                            <select
                                value={paymentStatusFilter}
                                onChange={(e) => {
                                    setPaymentStatusFilter(e.target.value);
                                }}
                                className="payments-select form-select invoice-select-date"
                                style={{ width: "100%", height: "2.5rem" }}
                            >
                                <option value={""}>All</option>
                                <option value="due">Due</option>
                                <option value="partiallypaid">Partially-Paid</option>
                                <option value="fullypaid">Fully-Paid</option>

                                { }
                            </select>
                        </div>
                        <div className="payments-select-container fin_man_billing_period" style={{ width: '180px' }}>
                            <p style={{ marginBottom: '1px' }}>Billing Period:&nbsp;</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label=""
                                    value={dayjs(`${billingYearFilter}-${billingMonthFilter}`)}
                                    views={['month', 'year']}
                                    className="payments-select"
                                    // minDate={dayjs('2022-01-01')} // Set minimum selectable date
                                    // maxDate={dayjs('2025-01-08')} // Set minimum selectable date
                                    onChange={(newValue) => {
                                        handleBillingPeriodChange(newValue);
                                    }
                                    }
                                    sx={{
                                        '.MuiInputBase-root': {
                                            height: '40px', // Adjust height
                                            backgroundColor: 'white', // Set background to white
                                            borderRadius: '6px', // Optional: Rounded corners
                                            fontSize: '14px', // Optional: Adjust text size
                                        },
                                    }}
                                // slotProps={{
                                //     textField: {
                                //         InputProps: {
                                //             readOnly: true, // Prevent typing in the input field
                                //         },
                                //         onKeyDown: (e) => e.preventDefault(), // Block keyboard inputs
                                //     },
                                // }}
                                />
                            </LocalizationProvider>


                        </div>
                        <div className='d-flex align-items-center gap-3 mb-3'>
                            <div className='fin_man_meter_search_bar_container'>
                                <input style={{ height: '2.5rem' }} type='search' placeholder='Search' value={searchText}
                                    onChange={handleSearchChange}
                                    className='search-input fin_man_meter_search_bar' />
                                <GoSearch className='search-input-icon fin_man_meter_search_bar_icon C-pointer' />
                            </div>

                        </div>
                        <div className='d-flex align-items-center gap-2'>
                            <button className="add_fac_apply_btn primary-button" style={{ marginTop: '4px', color: 'white', height: '20px !important' }} onClick={() => {
                                applyFilterClicked()
                            }}>Apply</button>
                            <button className="add_fac_clear_btn secondary-button" style={{ marginTop: '4px', color: 'white', height: '20px !important' }}
                                onClick={() => {
                                    clearFilterClicked()
                                }}
                            >Clear</button>

                        </div>

                    </div>


                    <div className='table_container_commercial_head'>
                        <TableComponent
                            headers={[
                                {
                                    name: "Contract Name ",
                                    type: "text",
                                    key: "contract_name",
                                    sort: true
                                },
                                {
                                    name: "Invoice Number",
                                    type: "text",
                                    key: "invoice_number",
                                    sort: true
                                }, {
                                    name: "Invoice Type ",
                                    type: "text",
                                    key: "invoice_type",
                                    sort: true
                                },
                                {
                                    name: "Issue Date",
                                    type: "date",
                                    key: "issue_date",
                                    sort: true
                                },
                                {
                                    name: "Due Date",
                                    type: "date",
                                    key: "due_date",
                                    sort: true
                                },
                                {
                                    name: `Invoiced Amount (${formatCurrencyBasedOnRegion()})`,
                                    type: "number",
                                    key: "invoiced_amount",
                                    sort: true,
                                    formatNumberWithComas: true
                                },
                                {
                                    name: `Total Received Amount (${formatCurrencyBasedOnRegion()})`,
                                    type: "number",
                                    key: "total_received_amount",
                                    sort: true,
                                    formatNumberWithComas: true
                                }, {
                                    name: `Amount Due (${formatCurrencyBasedOnRegion()})`,
                                    type: "number",
                                    key: "amount_due",
                                    sort: true,
                                    formatNumberWithComas: true
                                },
                                {
                                    name: "Payment Status",
                                    type: "text",
                                    key: "status",
                                    sort: true
                                },
                                {
                                    name: "Updated By",
                                    type: "text",
                                    key: "updated_by",
                                    sort: true
                                },
                                {
                                    name: "Last Updated At",
                                    type: "time_stamp",
                                    key: "updated_at",
                                    sort: true
                                },
                                {
                                    name: " Action ",
                                    type: "button",
                                    buttons: isManage ? [

                                        {
                                            name: "Edit",
                                            icon: "./images/icons/Vectoredit.svg",
                                            disable: handleEnable,
                                            action: (data) => handleViewActionClicked(data)
                                        },
                                        {
                                            name: "Send Mail",
                                            icon: "./images/icons/sendnotification.svg",
                                            disable: handleEnable,
                                            action: (data) => {
                                                sendPaymentMailConfirmation(data)
                                            }
                                        },
                                        {
                                            name: "Download",
                                            icon: "./images/icons/Download.svg",
                                            disable: handleEnable,
                                            action: (data) => { handleDownloadPayment(data) }
                                        },

                                    ] : [{
                                        name: "Edit",
                                        icon: "./images/icons/ViewViewIconEye.svg",
                                        disable: handleEnable,
                                        action: (data) => handleViewActionClicked(data)
                                    },
                                    {
                                        name: "Download",
                                        icon: "./images/icons/Download.svg",
                                        disable: handleEnable,
                                        action: (data) => { handleDownloadPayment(data) }
                                    },
                                    ]
                                }]}

                            data={allInvoicePayments}
                        />

                    </div>
                    <Pagination
                        handledPaginationNextClicked={handledPaginationNextClicked}
                        handledPaginationPrevClicked={handledPaginationPrevClicked}
                        isApplyClicked
                        totalRecords={totalRecords}
                        recordsPerPage={RECORDS_PER_PAGE_METER_MASTER}
                        currentPaginationPage={currentPaginationPage}
                    />
                </div>
            }
            {
                currentPage === 2 &&
                <div className="newPaymentContainer">
                    <div style={{ display: "flex", flexDirection: "column", margin: '10px', marginBottom: "100px" }}>
                        <div>
                            <h2>Payment Details</h2>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <label className='add-facility-modal-label' style={{ flexWrap: "nowrap", marginRight: "10px" }}>Contract Name: </label>
                            <spam><strong>{contractName}</strong></spam>
                        </div>
                        <div style={{ marginTop: "20px" }}>
                            <Tabs
                                activeKey={activeTab}
                                onSelect={(k) => setActiveTab(k)}
                                id="uncontrolled-tab-example"
                                className="mb-0"
                            >
                                <Tab eventKey="1" title="Payment Details"
                                    className="assetTabs"
                                // disabled={!viewClicked && !editClicked}
                                >
                                    <div className="infoBody">
                                        <div>
                                            <h7 style={{ fontWeight: "bold" }}>Invoice Information</h7>
                                            <div className="infoBodyInputs">
                                                <div className="responsiveInputSection">
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Contract Name </label>
                                                        <input type='text'
                                                            value={contractName}
                                                            disabled={true}
                                                            className='form-control responsive-add-facility-input-fields' />

                                                    </div>
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Invoice Number </label>
                                                        <input type='text'
                                                            value={invoiceNumber}
                                                            disabled={true}
                                                            className='form-control responsive-add-facility-input-fields' />

                                                    </div>
                                                    <div>
                                                        <label className='add-facility-modal-label'>Invoice Type</label>
                                                        <input type='text'
                                                            value={invoiceType}
                                                            disabled={true}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                </div>
                                                <div className="responsiveInputSection">
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Issued Date </label>
                                                        <input type='date'
                                                            value={issueDate}
                                                            disabled={true}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Due Date </label>
                                                        <input type='date'
                                                            value={dueDate}
                                                            disabled={true}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                    <div>
                                                        <label className='add-facility-modal-label'>Payment Status</label>
                                                        <input type='text'
                                                            value={paymentStatus}
                                                            disabled={true}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                </div>
                                                <div className="responsiveInputSection">
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Invoiced Amount</label>
                                                        <input type='number'
                                                            value={invoicedAmount}
                                                            disabled={true}
                                                            className='form-control responsive-add-facility-input-fields' />

                                                    </div>
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Total Amount Received </label>
                                                        <input
                                                            type='number'
                                                            value={totalReceivedAmount}
                                                            disabled={true}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                    <div>
                                                        <label className='add-facility-modal-label'>Due Amount</label>
                                                        <input type='text'
                                                            value={amountDue}
                                                            disabled={true}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                </div>
                                                <div className="responsiveInputSection">
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Base Amount</label>
                                                        <input type='number'
                                                            value={totalBaseAmount}
                                                            disabled={true}
                                                            className='form-control responsive-add-facility-input-fields' />

                                                    </div>
                                                    <div >

                                                        <label className='add-facility-modal-label'
                                                        >TDS % </label>
                                                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                                            <input
                                                                type='number'
                                                                value={tdsPercentage}
                                                                disabled={!editTdsClicked}
                                                                style={{ width: "80%" }}
                                                                onChange={(e) => {
                                                                    if (e.target.value <= 100) {
                                                                        setTdsPercentage(formatNumericparseFloatInput(e.target.value))
                                                                    }
                                                                }}
                                                                className='form-control' />
                                                            {
                                                                editTdsClicked ?
                                                                    null
                                                                    :
                                                                    isManage && <div
                                                                        style={{
                                                                            background: "white",
                                                                            padding: "9px 10px",
                                                                            borderRadius: "5px",
                                                                            width: "15%",
                                                                        }}
                                                                        className="C-pointer"
                                                                        onClick={() => {
                                                                            setEditTdsClicked(true)
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src="./images/icons/Edit.svg"
                                                                            alt="edit"
                                                                            style={{ height: "20px" }}
                                                                        />
                                                                    </div>

                                                            }

                                                        </div>
                                                    </div>
                                                    <div>
                                                        <label className='add-facility-modal-label'>TDS Amount</label>
                                                        <input type='text'
                                                            value={totalTDSAmount}
                                                            disabled={true}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                </div>
                                                <div className="responsiveInputSection">
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >CGST</label>
                                                        <input type='number'
                                                            value={totalCGSTAmount}
                                                            disabled={true}
                                                            className='form-control responsive-add-facility-input-fields' />

                                                    </div>
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >SGST</label>
                                                        <input
                                                            type='number'
                                                            value={totalSGSTAmount}
                                                            disabled={true}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                    <div>
                                                        <label className='add-facility-modal-label'>IGST</label>
                                                        <input type='text'
                                                            value={totalIGSTAmount}
                                                            disabled={true}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                </div>
                                                <hr></hr>
                                                <div>
                                                    <h7 style={{ fontWeight: "bold" }}>Adjustment Details</h7>
                                                </div>
                                                <div className="responsiveInputSection">
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Adjustment Amount</label>
                                                        <input type='number'
                                                            value={adjustmentAmount}
                                                            onChange={handleAdjustmentAmountChange}
                                                            disabled={!isManage}
                                                            className='form-control responsive-add-facility-input-fields' />

                                                    </div>
                                                    <div >
                                                        <label className='add-facility-modal-label'
                                                        >Adjustment Type</label>
                                                        <select value={adjustmentType}
                                                            onChange={handleAdjustmentTypeChange}
                                                            disabled={!isManage}
                                                            className='form-control responsive-add-facility-input-fields' >
                                                            <option value="">Select</option>
                                                            <option value="creditNote">Credit Note</option>
                                                            <option value="debitNote">Debit Note</option>
                                                            <option value="interest">Interest</option>
                                                            <option value="discount">Discount</option>
                                                        </select>
                                                    </div>
                                                    <div>
                                                        <label className='add-facility-modal-label'>Adjustment Reason</label>
                                                        <input type='text'
                                                            value={adjustmentReason}
                                                            onChange={handleAdjustmentReasonChange}
                                                            disabled={!isManage}
                                                            className='form-control responsive-add-facility-input-fields' />
                                                    </div>
                                                </div>
                                                <hr></hr>
                                                <div>
                                                    <div className='d-flex justify-content-between C-pointer' onClick={() => {
                                                        setIsExpandedCreditDebitNotes(prev => !prev)
                                                    }}>
                                                        <h7 style={{ fontWeight: "bold" }}>Credit/Debit Notes</h7>
                                                        {isExpandedCreditDebitNotes ? <HiChevronUp size={20} /> : <HiChevronDown size={20} />}
                                                    </div>
                                                    {isExpandedCreditDebitNotes &&
                                                        <div className="table_container_commercial_head">
                                                            <TableComponent headers={[{
                                                                name: "Date",
                                                                type: "date",
                                                                key: "payment_date",
                                                                sort: true
                                                            }, {
                                                                name: "Credit/Debit Note",
                                                                type: "text",
                                                                key: "entry_type",
                                                                sort: true
                                                            }, {
                                                                name: "Amount in (INR)",
                                                                type: "number",
                                                                key: "amount_paid",
                                                                sort: true
                                                            }, {
                                                                name: "Created By",
                                                                type: "text",
                                                                key: "created_by",
                                                                sort: true
                                                            }
                                                            ]}
                                                                data={creditDebitNotesList}
                                                            />
                                                        </div>}
                                                </div>

                                            </div>
                                        </div>
                                        <hr></hr>
                                        <div>
                                            <h7 style={{ fontWeight: "bold" }}>Payment Records</h7>
                                            
                                            <div className="infoBodyInputs">
                                                <div className='license_fee_details_table'>
                                                    <table>
                                                        <thead className='fin_man_table_head commercial-head-table text-center'>
                                                            <tr>
                                                                <th>S.No</th>
                                                                <th>Payment Date <span style={{ color: "red" }}>*</span></th>
                                                                <th>Payment Amount (<span>{formatCurrencyBasedOnRegion()}</span>)<span style={{ color: "red" }}>*</span></th>
                                                                <th>Account No. <span style={{ color: "red" }}>*</span></th>
                                                                <th style={{ textWrap: "nowrap" }}>Mode Of Payment<span style={{ color: "red" }}>*</span></th>
                                                                <th style={{ textWrap: "nowrap" }}>note</th>

                                                            </tr>

                                                        </thead>
                                                        <tbody className='fin_man_table_body'>
                                                            {
                                                                paymentRecordsRows.length > 0 ?
                                                                    // <>
                                                                    paymentRecordsRows.map((row, index) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td>{index + 1}</td>
                                                                                <td>
                                                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                        <DatePicker
                                                                                            label=""
                                                                                            disabled={row?.payment_detail_id}
                                                                                            className='form-control responsive-add-facility-input-fields'
                                                                                            value={dayjs(row?.payment_date)}
                                                                                            onChange={(e) => { handlePaymentRecordsRowChange(e, index, 'payment_date') }}
                                                                                            views={['day', 'month', 'year']}
                                                                                            minDate={dayjs(issueDate)} // Set minimum selectable date
                                                                                            // maxDate={dayjs('2025-01-31')} // Set minimum selectable date
                                                                                            format={localStorage.getItem("date_format")}
                                                                                            sx={{
                                                                                                '.MuiInputBase-root': {
                                                                                                    height: '35px', // Adjust height
                                                                                                    backgroundColor: 'white', // Set background to white
                                                                                                    borderRadius: '6px', // Optional: Rounded corners
                                                                                                    fontSize: '16px', // Optional: Adjust text size
                                                                                                },
                                                                                            }}

                                                                                        // slotProps={{
                                                                                        //     textField: {
                                                                                        //         InputProps: {
                                                                                        //             readOnly: true, // Prevent typing in the input field
                                                                                        //         },
                                                                                        //         onKeyDown: (e) => e.preventDefault(), // Block keyboard inputs
                                                                                        //     },
                                                                                        // }}
                                                                                        />
                                                                                    </LocalizationProvider>

                                                                                </td>
                                                                                <td>
                                                                                    <input type='number'
                                                                                        value={row?.amount_paid}
                                                                                        disabled={row?.payment_detail_id}
                                                                                        onChange={(e) => handlePaymentRecordsRowChange(e, index, 'amount_paid')}
                                                                                        className='form-control'
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    {row?.entry_type === "payment" ?
                                                                                        <input type='text'
                                                                                            value={row?.account_no}
                                                                                            disabled={row?.payment_detail_id}
                                                                                            onChange={(e) => handlePaymentRecordsRowChange(e, index, 'account_no')}
                                                                                            className='form-control'
                                                                                        />
                                                                                        :
                                                                                        <input type='text'
                                                                                            value={row?.reference_number}
                                                                                            disabled={row?.payment_detail_id}
                                                                                            onChange={(e) => handlePaymentRecordsRowChange(e, index, 'reference_number')}
                                                                                            className='form-control'
                                                                                        />}
                                                                                </td>
                                                                                <td>
                                                                                    {row?.entry_type === "payment" ?
                                                                                        <input type='text'
                                                                                            value={row.instrumentation_type}
                                                                                            disabled={row?.payment_detail_id}
                                                                                            onChange={(e) => handlePaymentRecordsRowChange(e, index, 'instrumentation_type')}
                                                                                            className='form-control'
                                                                                        />
                                                                                        :
                                                                                        <input type='text'
                                                                                            value={row.entry_type === "credit_note" ? "Credit Note" : "Debit Note"}
                                                                                            disabled={row?.payment_detail_id}
                                                                                            onChange={(e) => handlePaymentRecordsRowChange(e, index, 'entry_type')}
                                                                                            className='form-control'
                                                                                        />
                                                                                    }
                                                                                </td>
                                                                                <td>
                                                                                    <input type='text'
                                                                                        value={row.note}
                                                                                        disabled={row?.payment_detail_id}
                                                                                        onChange={(e) => handlePaymentRecordsRowChange(e, index, 'note')}
                                                                                        className='form-control'
                                                                                    />
                                                                                </td>

                                                                            </tr>
                                                                        )
                                                                    })
                                                                    //   </>
                                                                    :
                                                                    <tr>
                                                                        <td colSpan={5} className='text-center'>No Records Found, Please add a record</td>
                                                                    </tr>
                                                            }

                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div>

                                                {
                                                    paymentRecordsRows.filter(item => !item.payment_detail_id).reduce((sum, item) => sum + (parseFloat(item.amount_paid) || 0), 0) <= parseFloat(amountDue) ?
                                                        null
                                                        :
                                                        <spam style={{ color: "red" }}> Total amount paid should be less than or equal to {amountDue}</spam>
                                                }

                                            </div>

                                                {isManage && <>{
                                                    paymentRecordsRows.length === 0 &&
                                                    <div style={{ display: "flex", justifyContent: "end", marginTop: "10px" }}>
                                                        <img style={{ height: "18px", marginRight: "10px" }}
                                                            onClick={handleAddPaymentRecordRow}
                                                            src="./images/icons/PlusaddItem.svg" alt="add"
                                                            title="Add row below"
                                                        />
                                                    </div>
                                                }
                                                    {
                                                        paymentRecordsRows[paymentRecordsRows.length - 1]?.payment_date && paymentRecordsRows[paymentRecordsRows.length - 1]?.amount_paid && paymentRecordsRows[paymentRecordsRows.length - 1]?.account_no && paymentRecordsRows[paymentRecordsRows.length - 1]?.instrumentation_type &&
                                                        <div style={{ display: "flex", justifyContent: "end", marginTop: "10px" }}>
                                                            {paymentRecordsRows.filter(item => !item.payment_detail_id).reduce((sum, item) =>  sum + (parseFloat(item.amount_paid) || 0), 0) < parseFloat(amountDue) ?
                                                                <img style={{ height: "18px", marginRight: "10px" }}
                                                                    onClick={handleAddPaymentRecordRow}
                                                                    src="./images/icons/PlusaddItem.svg" alt="add"
                                                                    title="Add row below"
                                                                />
                                                                :
                                                                null

                                                            }
                                                            {
                                                                ((paymentRecordsRows.length > 1) && !(paymentRecordsRows[paymentRecordsRows.length - 1]?.payment_detail_id)) &&
                                                                <img style={{ height: "18px" }} src="./images/icons/MinusremoveItem.svg"
                                                                    onClick={() => handleRemovePaymentRecordRow(paymentRecordsRows.length - 1)}
                                                                    alt="remove"
                                                                    title="Delete last row"
                                                                />
                                                            }
                                                        </div>
                                                    }</>
                                                }


                                            </div>
                                        </div>
                                        <div style={{ marginTop: "20px" }}>
                                            <UploadComponent
                                                onFilesSelected={handleFilesSelected}
                                                uploadMethod="single"
                                                viewMode={!isManage}
                                                uploadedFileData={documentsListArray}
                                                uploadActionClicked={handleDocumentUpload}
                                                // deleteSpecificFileMain={confirmDeleteDocument}
                                                maxNumberOfFiles={5}
                                                handleErrorFromDocument={handleErrorFromDocument}
                                                idType={"payments"}
                                                acceptedFileTypes={".pdf, .jpeg, .jpg, .png"}
                                            />
                                        </div>
                                    </div>

                                </Tab>
                            </Tabs>
                        </div>
                        <div style={{ marginTop: "20px", }}>
                            <div style={{ display: "flex", justifyContent: "end", }}>
                                {
                                    tdsPercentage === '' ?
                                        null :
                                        isManage &&
                                        <button className="invoice_btn" style={{ marginTop: "20px", color: "white" }}
                                            disabled={
                                                (
                                                    (paymentRecordsRows.length === 0) ||
                                                    (paymentRecordsRows[paymentRecordsRows.length - 1]?.payment_date && paymentRecordsRows[paymentRecordsRows.length - 1].amount_paid && paymentRecordsRows[paymentRecordsRows.length - 1].account_no && paymentRecordsRows[paymentRecordsRows.length - 1].instrumentation_type)
                                                ) ?
                                                    false
                                                    :
                                                    true
                                            }
                                            onClick={handleSavePayment}
                                        >Save</button>

                                }
                                <button className="invoice_btn"
                                    onClick={() => {
                                        if (paymentStatus === "fullypaid") {
                                            backFunction()
                                        }
                                        else {
                                            if (isManage) {
                                                setAlertShow(true)
                                                setAlertType('question')
                                                setAlertMessage('Confirmation')
                                                setAlertValue("Are you sure you want to cancel? Any changes made will not be saved.")
                                                setAlertButtons([{
                                                    name: 'Yes', action: () => {
                                                        setAlertShow(false)
                                                        backFunction()
                                                    }
                                                }, {
                                                    name: 'No', action: () => {
                                                        setAlertShow(false)
                                                    }
                                                }])
                                            }
                                            else {
                                                backFunction()
                                            }

                                        }

                                    }}
                                    style={{ marginTop: "20px", color: "white", marginLeft: "10px" }}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <Footer />
        </>

    )
}
export default FinanceManagerPayments;
